import {Lang as UikitLang} from '@gravity-ui/uikit';

import {Lang} from '../constants';

const getFallbackLanguage = (lang: string) => {
    if ([Lang.Be, Lang.Kk, Lang.Uk].includes(lang as Lang)) {
        return UikitLang.Ru;
    }
    return UikitLang.En;
};
export default getFallbackLanguage;
